import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "is-label"
};
const _hoisted_2 = {
    key: 1,
    class: "is-label"
};
const _hoisted_3 = { class: "advanced-fields" };
const _hoisted_4 = { class: "cap-display" };
const _hoisted_5 = { class: "is-text-inside" };
const _hoisted_6 = { class: "cap-display" };
const _hoisted_7 = { class: "is-text-inside" };
const _hoisted_8 = {
    key: 1,
    class: "cap-display-full"
};
const _hoisted_9 = { class: "is-text-inside" };
const _hoisted_10 = { class: "test-fields" };
const _hoisted_11 = { class: "is-label" };
import _ from "lodash";
import BigNumber from "bignumber.js";
import moment from "moment";
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import i18n from "@/localization/localization.js";
import AuButton from "@/components/extended/AuButton.vue";
import AuDecimalStatic from "@/components/extended/AuDecimalStatic.vue";
import AuIcon from "@/components/extended/AuIcon.vue";
import AuTooltip from "@/components/extended/AuTooltip.vue";
import UForm from "@/components/uikit/uComponents/uForm/UForm.vue";
import UInput from "@/components/uikit/uComponents/UInput.vue";
import URow from "@/components/uikit/uLayouts/URow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectFormSecondStepV2',
    props: {
        id: {},
        tokensCount: {},
        showPriceRedeem: { type: Boolean },
        firstPartOfProjectInfo: {},
        secondPartOfProjectInfo: {}
    },
    emits: ["secondPartOfProjectInfo", "prevStep", "nextStep"],
    setup(__props, { emit: __emit }) {
        const t = (key) => i18n.global.t(key);
        const props = __props;
        const emit = __emit;
        const store = useStore();
        // Состояние
        const showAdvanced = ref(false);
        const showTest = ref(false);
        const loading = ref(false);
        const isFoundation = ref(false);
        // Вычисляемые свойства из Vuex
        const tokensFiat = computed(() => store.getters.tokensFiat);
        const tokensUtility = computed(() => store.getters.tokensUtility);
        const sectionCapital = computed(() => store.getters.sectionCapital);
        const requestsToIssue = computed(() => store.getters.requestsToIssue);
        const defaultAutMnemonic = computed(() => store.getters["defaultToken/defaultAutMnemonic"]);
        const defaultTokenEnv = computed(() => store.getters["defaultToken/defaultTokenEnv"]);
        const isTestRole = computed(() => store.getters["profile/isTestRole"]);
        // Опции для селектов
        const tokenQuotesOptions = computed(() => {
            const allTokens = [...tokensFiat.value, ...tokensUtility.value];
            const uniqueTokens = _.uniqBy(allTokens, "id");
            return uniqueTokens.map((token) => ({
                display: token.nameEng,
                value: `/api/au_tokens/${token.id}`,
                decimals: token.decimals
            }));
        });
        const capitalsSectionsOptions = computed(() => _.map(sectionCapital.value, section => ({
            display: section.name,
            value: `/api/section_capitals/${section.id}`
        })));
        const priceInMnemonic = computed(() => {
            const { projectType, applicationType } = props.firstPartOfProjectInfo || {};
            if (projectType === "voting" || applicationType === "stakingPool") {
                return defaultAutMnemonic.value;
            }
            return defaultTokenEnv.value;
        });
        const currentTokenDecimals = computed(() => {
            const token = _.find(tokenQuotesOptions.value, { value: initialFormValues.value.tokenQuote });
            return token?.decimals || 0;
        });
        // Минимальные даты
        const minDate = computed(() => {
            const now = new Date();
            return new Date(now.getTime() - now.getSeconds() * 1000 - now.getMinutes() * 60000 - now.getHours() * 3600000);
        });
        const minDateAfterMinDate = computed(() => {
            const dateStart = initialFormValues.value.dateStart;
            if (dateStart) {
                const startDate = new Date(dateStart);
                startDate.setMinutes(0, 0, 0);
                return new Date(startDate.getTime() + (24 * 60 * 60 * 1000) * 2);
            }
            return new Date(minDate.value.getTime() + (24 * 60 * 60 * 1000) * 2);
        });
        // Вычисляемые поля
        const minCap = computed(() => {
            const { minCol, priceBase, tokenQuote } = initialFormValues.value;
            if (!tokenQuote || !minCol || !priceBase) {
                return undefined;
            }
            const res = BigNumber(minCol).multipliedBy(priceBase).toString(10);
            return !isNaN(Number(res)) ? res : "0";
        });
        const maxCap = computed(() => {
            const { priceBase, tokenQuote } = initialFormValues.value;
            const tokensCountNum = props.tokensCount || "0";
            if (!tokenQuote || !priceBase) {
                return undefined;
            }
            const res = BigNumber(tokensCountNum).multipliedBy(priceBase).toString(10);
            return !isNaN(Number(res)) && Number(res) != 0 ? res : undefined;
        });
        const profit = computed(() => {
            if (!props.showPriceRedeem && initialFormValues.value.expectedProfit) {
                return initialFormValues.value.expectedProfit;
            }
            const { priceRedeem, priceBase, dateClose, dateEnd } = initialFormValues.value;
            if (!priceRedeem || !priceBase || !dateClose || !dateEnd) {
                return 0;
            }
            const pricePercent = ((Number(priceRedeem) - Number(priceBase)) * 100) / Number(priceBase);
            const daysDiff = moment(dateClose).diff(moment(dateEnd), "days");
            const yearCoefficient = Math.floor(365 / daysDiff);
            return pricePercent * yearCoefficient;
        });
        const mode = computed(() => props.id === "new"
            ? t("projects.form.secondStep.labelNew")
            : t("projects.form.secondStep.labelEdit"));
        // Начальные значения формы
        const initialFormValues = ref({
            minCount: null,
            minCol: 0,
            dateStart: null,
            dateEnd: null,
            firstPayout: null,
            section: null,
            assetType: process.env.VUE_APP_CAPITAL_ASSET_TYPES ?? "none",
            priceBase: 0,
            feePercent: "0",
            lockUpTerm: null,
            withdrawalDelayTime: null,
            bonusMultiplier: null,
            tokenQuote: null,
            quote: null,
            expectedProfit: null,
            priceRedeem: null,
            dateClose: null,
            projectTerms: null
        });
        // Валидаторы
        const validateMinCount = (value) => {
            if (value && BigNumber(value).isGreaterThan(props.tokensCount || "0")) {
                return t("projects.form.secondStep.tokenIntegerError");
            }
            return true;
        };
        const validateQuote = (value) => {
            const tokensCountNum = props.tokensCount || "0";
            if (value && BigNumber(value).isGreaterThan(tokensCountNum)) {
                return t("projects.form.secondStep.tokenIntegerError");
            }
            if (value && initialFormValues.value.minCount && BigNumber(value).isLessThan(initialFormValues.value.minCount)) {
                return t("projects.form.secondStep.tokenIntegerError");
            }
            return true;
        };
        const validateTokensInteger = () => {
            const { minCol, minCount, quote } = initialFormValues.value;
            let hasError = false;
            if (minCol && !BigNumber(minCol).isInteger()) {
                hasError = true;
            }
            if (minCount && !BigNumber(minCount).isInteger()) {
                hasError = true;
            }
            if (quote && !BigNumber(quote).isInteger()) {
                hasError = true;
            }
            return !hasError;
        };
        // Методы
        const setDefaultTokenQuote = () => {
            const { projectType, applicationType } = props.firstPartOfProjectInfo || {};
            let tokenMnemonic = "";
            if (projectType === "invest") {
                tokenMnemonic = defaultTokenEnv.value;
            }
            else if (projectType === "voting" || applicationType === "stakingPool") {
                tokenMnemonic = defaultAutMnemonic.value;
            }
            if (tokenMnemonic) {
                const token = _.find(tokensUtility.value, (item) => item.mnemonicEng === tokenMnemonic);
                if (token) {
                    initialFormValues.value.tokenQuote = `/api/au_tokens/${token.id}`;
                }
            }
        };
        const setDefaultPriceBase = () => {
            if (!initialFormValues.value.priceBase || initialFormValues.value.priceBase === 0 || initialFormValues.value.priceBase === "NaN") {
                initialFormValues.value.priceBase = BigNumber(1).multipliedBy(BigNumber(10).pow(currentTokenDecimals.value)).toString(10);
            }
        };
        const setFieldsFromExisting = () => {
            if (!props.secondPartOfProjectInfo) {
                return;
            }
            const data = props.secondPartOfProjectInfo;
            // Корректировка priceBase при смене decimals
            if (data.tokenDecimals !== currentTokenDecimals.value) {
                const priceCorrect = BigNumber(data.priceBase).dividedBy(BigNumber(10).pow(data.tokenDecimals));
                initialFormValues.value.priceBase = BigNumber(priceCorrect).multipliedBy(BigNumber(10).pow(currentTokenDecimals.value)).toString(10);
            }
            else {
                initialFormValues.value.tokenQuote = data.tokenQuote;
            }
            initialFormValues.value.projectTerms = data.projectTerms;
            initialFormValues.value.minCount = data?.minCount;
            initialFormValues.value.minCol = data.minCol;
            initialFormValues.value.dateStart = data.dateStart ? new Date(data.dateStart) : null;
            initialFormValues.value.dateEnd = data.dateEnd ? new Date(data.dateEnd) : null;
            initialFormValues.value.firstPayout = data?.firstPayout ? new Date(data.firstPayout) : null;
            initialFormValues.value.section = data.section;
            initialFormValues.value.assetType = data.assetType;
            initialFormValues.value.priceBase = data.priceBase;
            initialFormValues.value.quote = data.quote;
            initialFormValues.value.feePercent = data.feePercent;
            initialFormValues.value.lockUpTerm = data.lockUpTerm;
            initialFormValues.value.withdrawalDelayTime = data.withdrawalDelayTime;
            initialFormValues.value.bonusMultiplier = data.bonusMultiplier;
            initialFormValues.value.expectedProfit = data.expectedProfit ? data.expectedProfit.toString(10).replace(".", ",") : "";
            if (props.showPriceRedeem) {
                initialFormValues.value.priceRedeem = data.priceRedeem;
                initialFormValues.value.dateClose = data.dateClose ? new Date(data.dateClose) : null;
            }
        };
        const setFieldsFromRequest = () => {
            if (props.id === "new" || props.secondPartOfProjectInfo) {
                return;
            }
            const project = requestsToIssue.value.find((item) => item.id == props.id);
            if (!project) {
                return;
            }
            initialFormValues.value.minCount = project?.minCount;
            initialFormValues.value.minCol = isNaN(Number(BigNumber(project?.minCap).dividedBy(project.priceBase).toString(10)))
                ? ""
                : BigNumber(project?.minCap).dividedBy(project.priceBase).toString(10);
            initialFormValues.value.dateStart = new Date(Date.parse(project.dateStart));
            initialFormValues.value.dateEnd = new Date(Date.parse(project.dateEnd));
            initialFormValues.value.firstPayout = new Date(Date.parse(project?.firstPayout));
            initialFormValues.value.section = project.section;
            initialFormValues.value.projectTerms = project.terms;
            initialFormValues.value.assetType = project.assetType;
            initialFormValues.value.priceBase = project.priceBase;
            initialFormValues.value.tokenQuote = project.tokenQuote;
            initialFormValues.value.quote = project.quote;
            initialFormValues.value.expectedProfit = project.expectedProfit?.toString(10).replace(".", ",");
            if (props.showPriceRedeem) {
                initialFormValues.value.priceRedeem = project.priceRedeem;
                initialFormValues.value.dateClose = new Date(Date.parse(project.dateClose));
            }
        };
        const nextStep = (values) => {
            // Проверка обязательных полей
            const requiredFields = [
                { label: t("projects.form.secondStep.projectDateStartLabel"), value: values.dateStart },
                { label: t("projects.form.secondStep.projectExpectedProfitLabel"), value: values.expectedProfit },
                { label: t("projects.form.secondStep.projectSectionLabel"), value: values.section },
                { label: t("projects.form.secondStep.projectPriceBaseLabel"), value: values.priceBase },
                { label: t("projects.form.secondStep.projectAssetTypeLabel"), value: values.assetType }
            ];
            if (!isFoundation.value) {
                requiredFields.splice(1, 0, { label: t("projects.form.secondStep.projectDateEndLabel"), value: values.dateEnd });
            }
            const missingField = _.find(requiredFields, field => !field.value || field.value === "");
            if (missingField) {
                // TODO: показать ошибку через UForm
                return;
            }
            if (!validateTokensInteger()) {
                // TODO: показать ошибку через UForm
                return;
            }
            const secondPartOfProjectInfo = {
                dateStart: values.dateStart,
                dateEnd: values.dateEnd,
                firstPayout: values.firstPayout,
                section: values.section,
                assetType: values.assetType,
                terms: values.projectTerms,
                priceBase: values.priceBase,
                tokenQuote: values.tokenQuote,
                tokenMnemonic: values.tokenQuote,
                maxCap: maxCap.value,
                expectedProfit: profit.value.toString(),
                quote: values.quote,
                minCount: values.minCount,
                feePercent: values.feePercent,
                lockUpTerm: values.lockUpTerm,
                withdrawalDelayTime: values.withdrawalDelayTime,
                bonusMultiplier: values.bonusMultiplier,
                tokenDecimals: currentTokenDecimals.value,
                minCol: "",
                minCap: "",
                priceRedeem: "",
                dateClose: ""
            };
            if (values.minCol) {
                secondPartOfProjectInfo.minCol = values.minCol;
            }
            if (minCap.value && Number(minCap.value) > 0 && !isFoundation.value) {
                secondPartOfProjectInfo.minCap = minCap.value;
            }
            if (props.showPriceRedeem) {
                secondPartOfProjectInfo.priceRedeem = values.priceRedeem;
                secondPartOfProjectInfo.dateClose = values.dateClose;
            }
            emit("secondPartOfProjectInfo", secondPartOfProjectInfo);
            emit("nextStep");
        };
        const prevStep = () => {
            const secondPartOfProjectInfo = {
                minCount: initialFormValues.value.minCount,
                minCol: initialFormValues.value.minCol,
                dateStart: initialFormValues.value.dateStart,
                dateEnd: initialFormValues.value.dateEnd,
                firstPayout: initialFormValues.value.firstPayout,
                section: initialFormValues.value.section,
                assetType: initialFormValues.value.assetType,
                priceBase: initialFormValues.value.priceBase,
                feePercent: initialFormValues.value.feePercent,
                lockUpTerm: initialFormValues.value.lockUpTerm,
                withdrawalDelayTime: initialFormValues.value.withdrawalDelayTime,
                bonusMultiplier: initialFormValues.value.bonusMultiplier,
                tokenQuote: initialFormValues.value.tokenQuote,
                quote: initialFormValues.value.quote,
                expectedProfit: profit.value.toString() == "0" ? "" : profit.value.toString(),
                tokenMnemonic: initialFormValues.value.tokenQuote,
                tokenDecimals: currentTokenDecimals.value,
                projectTerms: initialFormValues.value.projectTerms,
                priceRedeem: "",
                dateClose: ""
            };
            if (props.showPriceRedeem) {
                secondPartOfProjectInfo.priceRedeem = initialFormValues.value.priceRedeem;
                secondPartOfProjectInfo.dateClose = initialFormValues.value.dateClose;
            }
            emit("secondPartOfProjectInfo", secondPartOfProjectInfo);
            emit("prevStep");
        };
        // Инициализация
        onMounted(async () => {
            isFoundation.value = props.firstPartOfProjectInfo?.applicationType == "foundation";
            // Загрузка данных
            if (_.isEmpty(requestsToIssue.value)) {
                await store.dispatch("getHydraRequestToIssue");
            }
            if (_.isEmpty(sectionCapital.value)) {
                await store.dispatch("getSectionCapital");
            }
            // Установка значений
            setDefaultTokenQuote();
            setFieldsFromExisting();
            setFieldsFromRequest();
            setDefaultPriceBase();
            if (!initialFormValues.value.dateStart) {
                initialFormValues.value.dateStart = new Date();
            }
        });
        // Следим за изменением tokenQuote для пересчета priceBase
        watch(() => initialFormValues.value.tokenQuote, () => {
            setDefaultPriceBase();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(UForm, {
                "initial-values": initialFormValues.value,
                loading: loading.value,
                "submit-button-text": "Next",
                onSubmitForm: nextStep
            }, {
                header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(mode.value) + " " + _toDisplayString(t('projects.form.secondStep.labelLastPart')), 1)
                ]),
                footerControls: _withCtx(() => [
                    _createVNode(AuButton, {
                        bordered: "",
                        center: "",
                        onClick: prevStep
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(t("projects.form.backButton")), 1)
                        ]),
                        _: 1
                    })
                ]),
                default: _withCtx(() => [
                    _createVNode(URow, { class: "select-date" }, {
                        default: _withCtx(() => [
                            _createVNode(UInput, {
                                name: "dateStart",
                                label: t('projects.form.secondStep.projectDateStartLabel'),
                                type: "date",
                                "min-date": minDate.value,
                                required: "",
                                placeholder: t('projects.form.secondStep.projectDateStartPlaceholder')
                            }, null, 8, ["label", "min-date", "placeholder"]),
                            _createVNode(UInput, {
                                name: "dateEnd",
                                label: t('projects.form.secondStep.projectDateEndLabel'),
                                type: "date",
                                "min-date": minDateAfterMinDate.value,
                                required: !isFoundation.value,
                                readonly: isFoundation.value,
                                placeholder: t('projects.form.secondStep.projectDateEndPlaceholder')
                            }, null, 8, ["label", "min-date", "required", "readonly", "placeholder"])
                        ]),
                        _: 1
                    }),
                    _createVNode(UInput, {
                        name: "firstPayout",
                        label: t('First payout'),
                        type: "date",
                        "min-date": minDate.value,
                        required: "",
                        placeholder: t('Enter first payout')
                    }, null, 8, ["label", "min-date", "placeholder"]),
                    (!__props.showPriceRedeem)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (__props.firstPartOfProjectInfo?.applicationType == 'stakingPool')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(t('projects.form.secondStep.projectAPYLabel')), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createTextVNode(_toDisplayString(t('projects.form.secondStep.projectExpectedProfitLabel')) + " ", 1),
                                    _createVNode(AuTooltip, { description: 'Expected value in percents which could be achieved in the year range.' })
                                ])),
                            _createVNode(UInput, {
                                name: "expectedProfit",
                                type: "number",
                                min: "0",
                                max: "100",
                                required: "",
                                placeholder: __props.firstPartOfProjectInfo?.applicationType == 'stakingPool'
                                    ? t('projects.form.secondStep.projectAPYPlaceholder')
                                    : t('projects.form.secondStep.projectExpectedProfitPlaceholder')
                            }, null, 8, ["placeholder"])
                        ], 64))
                        : _createCommentVNode("", true),
                    _createVNode(URow, null, {
                        default: _withCtx(() => [
                            _createVNode(UInput, {
                                name: "section",
                                label: t('projects.form.secondStep.projectSectionLabel'),
                                type: "select",
                                options: capitalsSectionsOptions.value,
                                required: "",
                                placeholder: t('projects.form.secondStep.projectSectionPlaceholder')
                            }, null, 8, ["label", "options", "placeholder"]),
                            _createVNode(UInput, {
                                name: "assetType",
                                label: t('projects.form.secondStep.projectAssetTypeLabel'),
                                required: "",
                                placeholder: t('projects.form.secondStep.projectAssetTypePlaceholder')
                            }, null, 8, ["label", "placeholder"])
                        ]),
                        _: 1
                    }),
                    (__props.showPriceRedeem)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(UInput, {
                                name: "priceRedeem",
                                label: t('projects.form.secondStep.projectPriceRedeemLabel'),
                                type: "number",
                                required: "",
                                placeholder: t('projects.form.secondStep.projectPriceRedeemPlaceholder')
                            }, null, 8, ["label", "placeholder"]),
                            _createVNode(UInput, {
                                name: "dateClose",
                                label: t('projects.form.secondStep.projectDateCloseLabel'),
                                type: "date",
                                "min-date": minDateAfterMinDate.value,
                                required: "",
                                placeholder: t('projects.form.secondStep.projectDateClosePlaceholder')
                            }, null, 8, ["label", "min-date", "placeholder"])
                        ], 64))
                        : _createCommentVNode("", true),
                    _createVNode(UInput, {
                        name: "projectTerms",
                        label: t('projects.form.secondStep.projectTermsLabel'),
                        type: "textarea",
                        "textarea-height": 75,
                        placeholder: t('projects.form.secondStep.projectTermsPlaceholder')
                    }, null, 8, ["label", "placeholder"]),
                    (__props.firstPartOfProjectInfo?.applicationType == 'stakingPool')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createVNode(UInput, {
                                name: "lockUpTerm",
                                label: t('projects.form.secondStep.lockUpTerm'),
                                type: "number",
                                decimal: 0,
                                placeholder: t('projects.form.secondStep.lockUpTermPlaceholder')
                            }, null, 8, ["label", "placeholder"]),
                            _createVNode(UInput, {
                                name: "withdrawalDelayTime",
                                label: t('projects.form.secondStep.withdrawalDelayTime'),
                                type: "number",
                                placeholder: t('projects.form.secondStep.withdrawalDelayTimePlaceholder')
                            }, null, 8, ["label", "placeholder"]),
                            _createVNode(UInput, {
                                name: "bonusMultiplier",
                                label: t('projects.form.secondStep.bonusMultiplier'),
                                type: "number",
                                decimal: 2,
                                max: "9999",
                                placeholder: t('projects.form.secondStep.bonusMultiplierPlaceholder')
                            }, null, 8, ["label", "placeholder"])
                        ], 64))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "is-advanced",
                        onClick: _cache[0] || (_cache[0] = ($event) => (showAdvanced.value = !showAdvanced.value))
                    }, [
                        _createElementVNode("span", null, _toDisplayString(t("projects.form.secondStep.projectAdvanced")), 1),
                        _createVNode(AuIcon, {
                            icon: showAdvanced.value ? 'chevron_up' : 'chevron_down',
                            clickable: ""
                        }, null, 8, ["icon"])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                        _createVNode(UInput, {
                            name: "priceBase",
                            label: t('projects.form.secondStep.projectPriceBaseLabel') + ' ' + priceInMnemonic.value,
                            type: "number",
                            decimal: currentTokenDecimals.value,
                            required: "",
                            placeholder: t('projects.form.secondStep.projectPriceBasePlaceholder')
                        }, null, 8, ["label", "decimal", "placeholder"]),
                        _createVNode(UInput, {
                            name: "minCol",
                            label: t('projects.form.secondStep.projectMinNumLabel'),
                            type: "number",
                            readonly: isFoundation.value,
                            max: __props.tokensCount,
                            placeholder: t('projects.form.secondStep.projectMinNumPlaceholder')
                        }, null, 8, ["label", "readonly", "max", "placeholder"]),
                        (__props.firstPartOfProjectInfo?.applicationType == 'stakingPool')
                            ? (_openBlock(), _createBlock(URow, { key: 0 }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(t('projects.form.secondStep.projectMinPriceLabel')), 1),
                                        _createVNode(AuDecimalStatic, {
                                            value: minCap.value,
                                            addition: priceInMnemonic.value,
                                            "show-addition": !!priceInMnemonic.value,
                                            decimal: currentTokenDecimals.value
                                        }, null, 8, ["value", "addition", "show-addition", "decimal"])
                                    ]),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("span", _hoisted_7, _toDisplayString(t('projects.form.secondStep.projectMaxPriceLabel')), 1),
                                        _createVNode(AuDecimalStatic, {
                                            value: maxCap.value,
                                            addition: priceInMnemonic.value,
                                            "show-addition": !!priceInMnemonic.value,
                                            decimal: currentTokenDecimals.value
                                        }, null, 8, ["value", "addition", "show-addition", "decimal"])
                                    ])
                                ]),
                                _: 1
                            }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("span", _hoisted_9, _toDisplayString(t('projects.form.secondStep.projectMaxPriceLabel')), 1),
                                _createVNode(AuDecimalStatic, {
                                    value: maxCap.value,
                                    addition: priceInMnemonic.value,
                                    "show-addition": !!priceInMnemonic.value,
                                    decimal: currentTokenDecimals.value
                                }, null, 8, ["value", "addition", "show-addition", "decimal"])
                            ])),
                        _createVNode(UInput, {
                            name: "minCount",
                            label: t('projects.form.secondStep.projectLimitMinCount'),
                            type: "number",
                            placeholder: t('projects.form.secondStep.projectLimitMinCountPlaceholder'),
                            "custom-rule": validateMinCount
                        }, null, 8, ["label", "placeholder"]),
                        _createVNode(UInput, {
                            name: "quote",
                            label: t('projects.form.secondStep.projectLimitOneHandLabel'),
                            type: "number",
                            placeholder: t('projects.form.secondStep.projectLimitPlaceholder'),
                            "custom-rule": validateQuote
                        }, null, 8, ["label", "placeholder"])
                    ], 512), [
                        [_vShow, showAdvanced.value]
                    ]),
                    (isTestRole.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createElementVNode("div", {
                                class: "is-advanced",
                                onClick: _cache[1] || (_cache[1] = ($event) => (showTest.value = !showTest.value))
                            }, [
                                _createElementVNode("span", null, _toDisplayString(t("projects.form.secondStep.projectTest")), 1),
                                _createVNode(AuIcon, {
                                    icon: showTest.value ? 'chevron_up' : 'chevron_down',
                                    clickable: ""
                                }, null, 8, ["icon"])
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createTextVNode(_toDisplayString(t('projects.form.secondStep.projectTokenQuoteLabel')) + " ", 1),
                                    _createVNode(AuTooltip, { description: '<div>Project token determined by project type:</div><li>USD — for investment project</li><li>AUT — for voting project</li>' })
                                ]),
                                _createVNode(UInput, {
                                    name: "tokenQuote",
                                    type: "select",
                                    options: tokenQuotesOptions.value,
                                    required: "",
                                    placeholder: t('projects.form.secondStep.projectTokenQuotePlaceholder')
                                }, null, 8, ["options", "placeholder"]),
                                _createVNode(UInput, {
                                    name: "feePercent",
                                    label: t('projects.form.secondStep.projectSystemСomission') + '%',
                                    type: "number",
                                    min: "0",
                                    max: "33",
                                    placeholder: t('projects.form.secondStep.projectSystemСomissionPlaceholder')
                                }, null, 8, ["label", "placeholder"])
                            ], 512), [
                                [_vShow, showTest.value]
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["initial-values", "loading"]));
        };
    }
});
